export default {
	/**
	 * invoke dotDotDot from here
	 */
	set(elem, showReadMore = false) {
		// detach the hidden overlay element if there is one. only used by the _phase_duration_overview partial
		const $detachedOverlay = $(elem)
			.children(".OverlayContainer__content")
			.detach();
		// @ts-expect-error
		$(elem).dotdotdot({
			/* The HTML to add as ellipsis. */
			ellipsis: "…",
			/* How to cut off the text/html: 'word'/'letter'/'children' */
			wrap: "letter",
			/* Whether to update the ellipsis: true/'window' */
			watch: false,
			lastCharacter: {
				remove: [" ", ",", ";", ".", "!", "?"],
			},
			after: "a.read-more",
			height: showReadMore ? 200 : null, // assume that all elements with a .read-more link should be 200 pixels high
			callback: showReadMore ? pp.dotDotDot.callback : undefined,
		});
		$(elem).append($detachedOverlay); // re-attach the overlay
	},

	/**
	 * put the original content of the element into a data attribute, then assign a listener to re-insert that content
	 */
	callback(isTruncated, origContent) {
		if (isTruncated) {
			$(this).data("orig-content", origContent);
			$(this).find("a.read-more").one("click", pp.dotDotDot.showMore);
		}
	},

	showMore(event) {
		event.preventDefault();
		$(event.currentTarget)
			.parent()
			.data("dotdotdot", false)
			.html($(event.currentTarget).parent().data("orig-content"));
	},
};
